export function pageIsTurboPreview() {
  return document.documentElement.dataset.turboPreview !== undefined
}
